<template>
    <div class="circular-progress-container">
        <svg viewBox="-10 -10 220 220" style="transform:rotate(-90deg)">
            <circle r="100" cx="100" cy="100" fill="transparent" stroke="var(--body-light-muted-color)" stroke-width="20px"></circle>
            <circle r="100" cx="100" cy="100" stroke="var(--blue-bright)" stroke-width="20px" stroke-linecap="round" v-bind:stroke-dashoffset="dashOffset" fill="transparent" stroke-dasharray="625px"></circle>
        </svg>

        <!-- Percentage Text -->
        <div class="circular-progress-number">
            <ui-animated-number v-bind:value="Number(percents)" suffix="%"/>
        </div>
    </div>
</template>

<script>
import UiAnimatedNumber from '~/components/UiAnimatedNumber.vue';

export default {
    props: {
        percents: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    computed: {
        dashOffset() {
            return 625 - ((625 / 100) * this.percents).toFixed(0) + 'px';
        },
    },
    components: {
        UiAnimatedNumber,
    },
};
</script>

<style scoped>
.circular-progress-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    margin: 12px 0;

    svg {
        width: 64px;
        height: 64px;
    }
}

.circular-progress-number {
    position: absolute;
    font-size: 18px;
    font-weight: 500;
    color: var(--blue-bright) !important;
}
</style>
